var map = {
	"./monster-1.png": 1686,
	"./monster-2.png": 1687,
	"./monster-23.png": 1688,
	"./monster-3.png": 1689,
	"./monster-4.png": 1690,
	"./monster-5.png": 1691,
	"./monster-6.png": 1692,
	"./monster-7.png": 1693,
	"./monster-8.png": 1694,
	"./monster-9.png": 1695
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;



//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters ^\.\/monster\-.*\.png$
// module id = 693
// module chunks = 0